// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"13633316","455":"ea448e72","977":"6454ac20"}[chunkId] + ".chunk.js";
};